import Card from './components/card'
import Logo from './components/logo'
import AppLinkLogo from './components/app-link-logo'
import HeaderFields from './components/header-fields'
import Barcode from './components/barcode'
import StripImage from './components/strip-image'
import SecondaryAndAuxillaryFields from './components/secondary-and-auxillary-fields.jsx'

const StoreCard = ({ passFieldCount }) => {

  return (
    <div className="relative">
      <Card>
        <Logo />
        <HeaderFields maxFields={passFieldCount.header} />
        <StripImage />
        <SecondaryAndAuxillaryFields passFieldCount={passFieldCount} />
        <AppLinkLogo />
        <Barcode />
      </Card>
      <Clipmap />
    </div>
  )
}

export default StoreCard

const Clipmap = () => (
  <svg className='apple-svg-clip absolute top-0'>
    <defs>
      <clipPath id="apple_clip_path">
        <rect id="clip" width="375" height="523" rx="10" ry="10" />
      </clipPath>
    </defs>
    <use href="#clip" />
  </svg>
)